import { withDependencies } from '@wix/thunderbolt-ioc'
import type { BrowserWindow, IAppDidMountHandler } from '@wix/thunderbolt-symbols'
import { BrowserWindowSymbol } from '@wix/thunderbolt-symbols'

const embeddedInIframeFactory = (window: NonNullable<BrowserWindow>): IAppDidMountHandler => {
	const notifySiteHeight = (siteHeight: number) => {
		window.parent.postMessage(
			{
				siteHeight,
			},
			'*'
		)
	}

	// TODO https://jira.wixpress.com/browse/TB-9015
	const setZoomProperty = (zoom: number | string) => {
		const zoomStringRegex = /^(normal|reset|\d+(\.\d+)?%?)$/
		if (typeof zoom === 'number' || (typeof zoom === 'string' && zoomStringRegex.test(zoom))) {
			// @ts-ignore
			// dom-id-usage-check-ignore-next-line -- masterPage is a permanent structural node whose id is never removed
			const masterPage: HTMLElement = window.document.getElementById('masterPage')
			Object.assign(masterPage.style, { zoom })
		}
	}

	return {
		async appDidMount() {
			if (window.parent === window) {
				return
			}

			addEventListener('message', (event) => {
				if (event.data.zoom) {
					setZoomProperty(event.data.zoom)
				}
			})
			// @ts-ignore
			// dom-id-usage-check-ignore-next-line -- masterPage is a permanent structural node whose id is never removed
			const masterPage: HTMLElement = window.document.getElementById('masterPage')
			const getSiteHeight = () => masterPage.offsetHeight

			notifySiteHeight(getSiteHeight())

			// @ts-ignore
			const resizeObserver = new window.ResizeObserver(() => notifySiteHeight(getSiteHeight()))
			resizeObserver.observe(masterPage)
		},
	}
}

export const EmbeddedInIframe = withDependencies([BrowserWindowSymbol], embeddedInIframeFactory)
